import React from "react";
import styled from "styled-components";

const LegalPage_ = styled.div`
  background: #f3f3f3;
  padding: 60px 15px 100px 15px;

  .h1 {
    margin: 0 auto 16px auto;
    max-width: 700px;
    text-align: center;
    font-family: RfdBold, sans-serif;
    font-weight: 700;
    font-size: 38px;
    line-height: 46px;
    color: #1d1d1d;
  }

  .updated {
    margin: 0 auto 50px auto;
    width: fit-content;
    font-size: 14px;
    color: var(--text_green);
  }

  .border {
    margin: 50px 0;
    width: 100%;
    height: 1px;
    background: var(--text_green);
  }

  @media (max-width: 820px) {
    padding: 30px 15px 60px 15px;

    .h1 {
      font-size: 22px;
      line-height: 26px;
    }
  }
`;

const Content_ = styled.div`
  max-width: 800px;
  width: 100%;
  margin: 0 auto;

  section {
    margin-bottom: 36px;
  }

  h2 {
    margin-bottom: 12px;
    font-family: RfdBold, sans-serif;
    font-weight: 700;
    font-size: 20px;
    line-height: 26px;
    color: var(--green);
  }

  p {
    font-size: 16px;
    line-height: 24px;
    color: #1d1d1d;
  }
`;

export const LegalPageLayout = ({ title, updatedAt, sections }) => {
  return (
    <LegalPage_>
      <div className="h1">{title}</div>
      {updatedAt && <div className="updated">{updatedAt}</div>}
      <Content_>
        {sections.map((section, index) => (
          <section key={index}>
            <h2>{section.heading}</h2>
            <p>{section.text}</p>
          </section>
        ))}
      </Content_>
    </LegalPage_>
  );
};
